'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import { deriveErrorDigest } from '@/lib/utils/derive-error-digest';

export const useReportError = ({ error }: { error: unknown }) => {
  useEffect(() => {
    if (!error) return;

    // An error carrying a digest comes from a Server Component render and is already
    // reported by `onRequestError` with its server stack; the client copy only has the
    // stripped generic message.
    if (deriveErrorDigest(error)) return;

    Sentry.captureException(error);
  }, [error]);
};
